import React from "react";
import {
  RequestStatusPausedIcon,
  RequestStatusCompletedIcon,
  RequestStatusDraftIcon,
  RequestStatusAssignedIcon,
  RequestStatusInProgressIcon,
  RequestStatusFinishedIcon,
  RequestStatusCancelledIcon,
} from "../Icons";

export const StatusIcon = ({ status }: { status: string }) => {
  switch (status) {
    case "pause":
      return <RequestStatusPausedIcon />;
    case "connector":
      return <RequestStatusCompletedIcon />;
    case "pencil":
      return <RequestStatusDraftIcon />;
    case "assigned":
      return <RequestStatusAssignedIcon />;
    case "clock":
      return <RequestStatusInProgressIcon />;
    case "tick":
      return <RequestStatusFinishedIcon />;
    case "cancel":
      return <RequestStatusCancelledIcon />;
    default:
      return null;
  }
};
